module.exports = __webpack_public_path__ + "img/xny7.e13ccb7b.png";